/*jshint esversion: 6 */


// name, path, folder, chunk, redirect, auth, props, before_render, children

function UltraRoute(payload) {
    let ultra_route = {};
    if (payload.path) {
      ultra_route.path = payload.path;
    } else {
      ultra_route.path = payload.name.toLowerCase();
    }
    if (payload.name) {
      ultra_route.name = payload.name;
    }
    if (payload.redirect) {
      ultra_route.redirect = {name: payload.redirect};
    }
    if (payload.auth) {
      ultra_route.meta = {requiresAuth: payload.auth};
    }
    if (payload.props) {
      ultra_route.props = payload.props;
    }
    if (payload.before_enter) {
      ultra_route.beforeEnter = payload.before_enter;
    }
    if (payload.children) {
      ultra_route.children = payload.children;
    }
    if (payload.folder) {
      if (payload.slot) {
        ultra_route.components = {
           [payload.slot]: () => import(
            `@/views/${payload.folder}/${payload.file?payload.file:payload.name}.view.vue`
            )
         };
      } else {
        ultra_route.component = () => import(
          `@/views/${payload.folder}/${payload.file?payload.file:payload.name}.view.vue`
          )
      }
    }
    return ultra_route;
}
export default UltraRoute;
